// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { quickOrderPageContainerStyles } from "@awc/Overrides/Widgets/QuickOrder/QuickOrderPageContainer";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

quickOrderPageContainerStyles.container = {
    gap: 0,
};

quickOrderPageContainerStyles.innerContainer = {
    offsetCss: css`
        align-items: baseline;
    `,
};

quickOrderPageContainerStyles.secondGridItem = {
    width: 12,
    css: css`
        display: flex;
        justify-content: space-between;
        &&& {
            margin-bottom: 18px;
        }
        & > div {
            width: auto;
            ${xScreen("lte", "sm")} {
                display: none;
            }
        }
    `,
};
quickOrderPageContainerStyles.thirdGridItem = {
    width: 12,
    css: css`
        &&& {
            margin-bottom: 25px;
        }
    `,
};

quickOrderPageContainerStyles.bottomGridContainer = {
    gap: 20,
    offsetCss: css`
        ${xScreen("lte", "sm")} {
            flex-direction: column-reverse;
            & > div {
                max-width: 100%;
                flex-basis: 100%;
            }
        }
    `,
};
